// extracted by mini-css-extract-plugin
export default {"container":"CustomButtons_container__-Dke4","mulbutton":"CustomButtons_mulbutton__6xKXh"};